import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'timeFormatMeridiem'
})
export class TimeFormatMeridiemPipe implements PipeTransform {
/**
  * Accepts string  and returns value of time using 12 hours format (AM or PM).
  *
  * @param {string} value string.
  */
  transform(time: string): string {
    if (time !== undefined) {
      return moment(time, ["HHmm"]).format("LT");

    }
    return 'N/A';

  }

}
